import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { parametersAtom } from '@store';

export const useLiveAnalysisSupportedParameters = () => {
    const parameters = useAtomValue(parametersAtom);

    return useMemo(() => parameters?.filter(({ parameter }) => parameter.supportedLive), [parameters]);
};
